import { usersReportAccess } from '../store/auth/userTypes'
import { triageLevelStates } from '../store/reports/types'
import { usersReportRoles } from '../store/users/types'

const filterCasesBy = [
  {
    label: 'Most Recent',
    value: 'mostRecent',
  },
  {
    label: 'Alphabetically',
    value: 'alphabetically',
  },
  {
    label: 'By Last Name of Subject',
    value: 'subjectLastName',
  },
  {
    label: 'By Location',
    value: 'location',
  },
  {
    label: 'By Case Number',
    value: 'caseNumber',
  },
  {
    label: 'By Tier Level',
    value: 'tierLevel',
  },
]

const ascedingDescendingOptions = [
  {
    label: 'Ascending',
    value: 'created_at',
  },
  {
    label: 'Descending',
    value: '-created_at',
  },
]

const startPageSections = [
  {
    label: 'Immediate Attention Required',
    value: 'immediate',
  },
  {
    label: 'Requires Triage',
    value: 'requireTriage',
  },
  {
    label: 'Under Investigation',
    value: 'underInvestigation',
  },
  {
    label: 'Additional Information Required',
    value: 'additionalInformationRequired',
  },
]

const triageLevels = [
  {
    label: 'Immediate Attention Required',
    value: triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED,
  },
  {
    label: 'Addressed and Resolved with Reporting Party',
    value: triageLevelStates.ADDRESSED_AND_RESOLVED,
  },
  {
    label: 'Transfer Report for Assignment',
    value: triageLevelStates.TRANSFERED_FOR_ASSIGNMENT,
  },
  {
    label: 'Additional Information Required',
    value: triageLevelStates.ADDITIONAL_INFORMATION_REQUIRED,
  },
  {
    label: 'Accept and Assign Report for Investigation',
    value: triageLevelStates.ACCEPTED_AND_ASSIGNED,
  },
]

const triageLevelsLight = [
  {
    label: 'Immediate Attention Required',
    value: triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED,
  },
  {
    label: 'Addressed and Resolved with Reporting Party',
    value: triageLevelStates.ADDRESSED_AND_RESOLVED,
  },
  {
    label: 'Transfer Report for Assignment',
    value: triageLevelStates.TRANSFERED_FOR_ASSIGNMENT,
  },
  {
    label: 'Additional Information Required',
    value: triageLevelStates.ADDITIONAL_INFORMATION_REQUIRED,
  },
  {
    label: 'Under Investigation',
    value: triageLevelStates.ACCEPTED_AND_ASSIGNED,
  },
  {
    label: 'Resolve and Archive',
    value: triageLevelStates.RESOLVE_AND_ARCHIVE,
  },
]

const archiveJumpToSection = [
  {
    label: 'Resolved Cases',
    value: 'resolvedCases',
  },
  {
    label: 'Case Transfers',
    value: 'caseTransfers',
  },
]

const yesNo = [
  {
    label: 'Yes',
    value: 'YES',
  },
  {
    label: 'No',
    value: 'NO',
  },
]

const tierLevels = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
]
const userRolesOptions = [
  {
    label: 'Administrator',
    value: 'ADMIN',
  },
  {
    label: 'Designated Receiver',
    value: 'DESIGNATED_RECEIVER',
  },
]

const caseOverviewQuestions = [
  {
    label: 'Case Name',
    value: 'caseName',
  },
  {
    label: 'Case Status',
    value: 'caseStatus',
  },
  {
    label: 'Case Summary',
    value: 'caseSummary',
  },
  {
    label: 'Attorney/Client Privilege',
    value: 'clientPrivilege',
  },
  {
    label: 'Tier Level',
    value: 'tierLevel',
  },
  {
    label: 'Team',
    value: 'team',
  },
  {
    label: 'Case Types',
    value: 'caseTypes',
  },
  {
    label: 'Important Dates',
    value: 'importantDates',
  },
  {
    label: 'Subjects',
    value: 'subjects',
  },
  {
    label: 'Victims',
    value: 'victims',
  },
  {
    label: 'Reporting Party',
    value: 'reportingParty',
  },
  {
    label: 'Workplace Injury',
    value: 'workplaceInjury',
  },
  {
    label: 'Location of Incident',
    value: 'locationOfIncident',
  },
  {
    label: 'OSHA Workplace Violence Type',
    value: 'osha',
  },
  {
    label: 'Nature of Incident',
    value: 'natureOfIncident',
  },
  {
    label: 'Was Law Enforcement or Security Contacted?',
    value: 'lawEnforcement',
  },
  {
    label: 'Days of Lost Time Away From Work',
    value: 'daysOffWork',
  },
  {
    label: 'Days of Lost Time On Job Transfer or Restriction',
    value: 'daysLostOnTransfer',
  },
]

const subjectTypes = [
  {
    label: 'Unknown Subject',
    value: 'UNKNOWN',
  },
  {
    label: 'Former Employee',
    value: 'FORMER_EMPLOYEE',
  },
  {
    label: 'Current Employee',
    value: 'CURRENT_EMPLOYEE',
  },
  {
    label: 'Former Contractor',
    value: 'FORMER_CONTRACTOR',
  },
  {
    label: 'Current Contractor',
    value: 'CURRENT_CONTRACTOR',
  },
  {
    label: 'Customer',
    value: 'CUSTOMER',
  },
  {
    label: 'Client',
    value: 'CLIENT',
  },
  {
    label: 'Supplier',
    value: 'SUPPLIER',
  },
  {
    label: 'Partner',
    value: 'PARTNER',
  },
  {
    label: 'Competitor',
    value: 'COMPETITOR',
  },
  {
    label: 'Law Enforcement',
    value: 'LAW_ENFORCEMENT',
  },
  {
    label: 'Regulatory Agent',
    value: 'REGULATORY_AGENT',
  },
  {
    label: 'Unrelated Party',
    value: 'UNRELATED_PARTY',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
]

const reportingPartyTypes = [
  {
    label: 'Unknown',
    value: 'UNKNOWN',
  },
  {
    label: 'Anonymous',
    value: 'ANONYMOUS',
  },
  {
    label: 'Fictitious name',
    value: 'FICTITIOUS_NAME',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
]

const caseTypeOptions = [
  {
    label: 'Threat',
    value: 'THREAT',
  },
  {
    label: 'Assault',
    value: 'ASSAULT',
  },
  {
    label: 'Bullying',
    value: 'BULLYING',
  },
  {
    label: 'Intimate Partner Violence',
    value: 'INTIMATE_PARTNER_VIOLENCE',
  },
  {
    label: 'Stalking',
    value: 'STALKING',
  },

  {
    label: 'Weapon on Company Property',
    value: 'WEAPON_ON_COMPANY_PROPERTY',
  },
  {
    label: 'Concerning Communication',
    value: 'CONCERNING_COMMUNICATION',
  },
  {
    label: 'Risk of Self-harm',
    value: 'RISK_OF_SELF_HARM',
  },
  {
    label: 'Risk to Others',
    value: 'RISK_TO_OTHERS',
  },

  {
    label: 'Anonymous Communication',
    value: 'ANONYMOUS_COMMUNICATION',
  },
  {
    label: 'Vandalism',
    value: 'VANDALISM',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
]
const yesNoUnknow = [
  {
    label: 'Yes',
    value: 'yes',
  },
  {
    label: 'No',
    value: 'no',
  },
  {
    label: 'Unknown',
    value: 'unknown',
  },
]

const exportCaseTypeOptions = [
  {
    label: 'Export Raw Data',
    value: 'csv',
  },
  {
    label: 'Export Case File',
    value: 'zip',
  },
]

const exportPageOptions = [
  {
    label: 'Export Case File',
    value: 'zip',
  },
  {
    label: 'Export OSHA report for this time period',
    value: 'xls',
  },
  {
    label: 'Export Raw Data',
    value: 'csv',
  },
]

const accessRolesOptions = [
  {
    label: 'Can Edit',
    value: usersReportAccess.CAN_EDIT,
  },
  {
    label: 'Can View',
    value: usersReportAccess.CAN_VIEW,
  },
]

const caseRolesOptions = [
  {
    label: 'Lead Investigator',
    value: usersReportRoles.LEAD_INVESTIGATOR,
  },
  {
    label: 'Team Member',
    value: usersReportRoles.TEAM_MEMBER,
  },
  {
    label: 'Oversight',
    value: usersReportRoles.OVERSIGHT,
  },
]

export default {
  filterCasesBy,
  startPageSections,
  triageLevels,
  triageLevelsLight,
  archiveJumpToSection,
  yesNo,
  tierLevels,
  userRolesOptions,
  caseOverviewQuestions,
  subjectTypes,
  caseTypeOptions,
  yesNoUnknow,
  exportCaseTypeOptions,
  exportPageOptions,
  ascedingDescendingOptions,
  accessRolesOptions,
  caseRolesOptions,
  reportingPartyTypes
}
